{
  "name": "@duosecurity/duo_universal",
  "version": "3.0.0",
  "description": "Node.js implementation of the Duo Universal SDK.",
  "keywords": [
    "duo",
    "duo security"
  ],
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/duosecurity/duo_universal_nodejs.git"
  },
  "homepage": "https://github.com/duosecurity/duo_universal_nodejs#readme",
  "bugs": {
    "url": "https://github.com/duosecurity/duo_universal_nodejs/issues"
  },
  "packageManager": "pnpm@10.13.1",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.mts",
        "default": "./dist/index.mjs"
      },
      "require": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      }
    }
  },
  "engines": {
    "node": ">=20"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup --env.NODE_ENV production",
    "prepublishOnly": "pnpm build",
    "lint": "eslint ./src --fix",
    "test": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "axios": "^1.10.0",
    "jose": "^6.0.11"
  },
  "devDependencies": {
    "@eslint/js": "^9.30.1",
    "@types/node": "^22.16.3",
    "@vitest/coverage-v8": "^3.2.4",
    "eslint": "^9.30.1",
    "eslint-config-prettier": "^10.1.5",
    "eslint-plugin-prettier": "^5.5.1",
    "prettier": "^3.6.2",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.36.0",
    "vitest": "^3.2.4"
  },
  "overrides": {
    "glob-parent": "^6.0.2"
  }
}
